var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "url(#paint0_linear_153_5931)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 22.5556V18C32 16.3431 30.6569 15 29 15H16C14.3431 15 13 16.3431 13 18V46C13 47.6569 14.3431 49 16 49H48C49.6569 49 51 47.6569 51 46V25.5556C51 23.8987 49.6569 22.5556 48 22.5556H32ZM20.6 45.2222H16.8V41.4444H20.6V45.2222ZM20.6 37.6667H16.8V33.8889H20.6V37.6667ZM20.6 30.1111H16.8V26.3333H20.6V30.1111ZM20.6 22.5556H16.8V18.7778H20.6V22.5556ZM28.2 45.2222H24.4V41.4444H28.2V45.2222ZM28.2 37.6667H24.4V33.8889H28.2V37.6667ZM28.2 30.1111H24.4V26.3333H28.2V30.1111ZM28.2 22.5556H24.4V18.7778H28.2V22.5556ZM47.2 45.2222H32V41.4444H35.8V37.6667H32V33.8889H35.8V30.1111H32V26.3333H47.2V45.2222ZM43.4 30.1111H39.6V33.8889H43.4V30.1111ZM43.4 37.6667H39.6V41.4444H43.4V37.6667Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_153_5931",
    x1: 0,
    y1: 0,
    x2: 64,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93F090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60BFB7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsBusiness);
export default __webpack_public_path__ + "static/media/settings_business.7ba7b882e91d2593120b9bc440f5d265.svg";
export { ForwardRef as ReactComponent };